import styled from 'styled-components';

const StyledTips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  justify-content: center;
`;

export { StyledTips };
